export default "__VITE_ASSET__Yz1mBfyw__"